import { IPlanKey, IShopPlanState } from '../types';

export const DEFAULT_TRIAL_DAYS = 14;
export const DEFAULT_PLAN_KEY: IPlanKey = IPlanKey.TRIAL_FUNNEL_OPT;

export const PATH_ANALYSIS_AVAILABLE = [
  IShopPlanState.ACTIVE_FUNNEL_OPT,
  IShopPlanState.ACTIVE_FUNNEL_OPT_AND_TRIAL_FUNNEL_OPT,
  // IShopPlanState.ACTIVE_PAGE_OPT_AND_TRIAL_FUNNEL_OPT, // TODO: confirm design
  IShopPlanState.TRIAL_FUNNEL_OPT,
];

export const TRIAL_DAYS_LEFT_TO_SHOW_NOTICE = 2;
